import React from 'react';
import { Box, Typography } from '@mui/material';
import { useReportConfig } from '../../../contexts/ReportConfigContext.jsx';

export default function DomainView({ title, data }) {
  const { isDomainEnabled } = useReportConfig();
  const domainKey = title.toLowerCase().replace(/\s+/g, '_');

  if (!isDomainEnabled(domainKey)) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Domínio {title} desabilitado na configuração do relatório.
        </Typography>
      </Box>
    );
  }

  const isEmptyObject =
    data && typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0;
  const isEmptyArray = Array.isArray(data) && data.length === 0;
  const hasData = data && !isEmptyObject && !isEmptyArray;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {title}
      </Typography>
      {!hasData ? (
        <Typography variant="body2" color="text.secondary">
          Sem dados para este domínio.
        </Typography>
      ) : (
        <Box
          component="pre"
          sx={{
            maxHeight: '70vh',
            overflow: 'auto',
            p: 2,
            bgcolor: '#f7fafc',
            borderRadius: 1,
            fontSize: 12,
          }}
        >
          {JSON.stringify(data, null, 2)}
        </Box>
      )}
    </Box>
  );
}
